import React from 'react';
import { theme } from '@fiverr-private/theme';
import { Typography } from '@fiverr-private/typography';
import { formatDate } from '../../utils';

interface DateLineProps {
  date: string;
  marginTop?: keyof typeof theme.spacing;
  fontWeight?: 'normal' | 'bold';
}

export const DateLine = ({ date, marginTop = '4', fontWeight = 'normal' }: DateLineProps) => {
  const formattedDate = formatDate(new Date(date));
  return (
    <Typography
      as="time"
      dateTime={formattedDate}
      size="b_sm"
      fontWeight={fontWeight}
      marginTop={marginTop}
      marginBottom="1"
      color="grey_700"
      height="22px"
      lineHeight="b_sm"
      style={{ display: 'block' }}
    >
      {formattedDate}
    </Typography>
  );
};
